import { Helper } from '../Helper';
export class ArrSomeHelper extends Helper {
    constructor(options) {
        super();
        this.map =
            options.map === undefined
                ? () => {
                }
                : options.map;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Enumerator.Create');
        sb.emitHelper(node, options, sb.helpers.rawEnumeratorSome({
            each: this.map,
        }));
    }
}

//# sourceMappingURL=ArrSomeHelper.js.map
